import { RouterView } from "vue-router";
import { CompanyAnnounceRouting } from "./company-announce/company-announce.routing";
import { CompanyCulturalRouting } from "./company-cultural/company-cultural.routing";
import { CompanyNewsRouting } from "./company-news/company-news.routing";

export const InformationManageRouting = {
  path: "/information-manage",
  name: "information-manage",
  redirect: "/information-manage/company-news/list",
  component: RouterView,
  meta: { title: "资讯管理", icon: "news" },
  children: [
    ...CompanyNewsRouting,
    ...CompanyAnnounceRouting,
    ...CompanyCulturalRouting
  ],
};
